module.exports = __webpack_public_path__ + "img/customize_products_1.af9d8e16.webp";